import { Injectable } from '@angular/core';

import { Constants } from '../shared/constants';
import { ApiService } from './api.service';

@Injectable({
    providedIn: 'root'
})
export class LoginService {

    constructor(private apiService: ApiService) { }



    async login(payload: any) {
        return await this.apiService.post(Constants.API_URL_LOGIN, payload)
            .toPromise()
            .catch(this.apiService.handleError('loginDetails', []));
    }


}
